<div class="d-flex justify-content-center align-items-center flex-column empty-search">
  <mat-icon class="large">insert_drive_file</mat-icon>
  <span>{{ 'mazeditor.noFileSelected' | translate }}</span>
</div>
